module.exports = __webpack_public_path__ + "img/hairgallery.1fe034f5.png";